import { getCustomTargetGrossMargin } from '@calculations/price/strategies/cap-price-segmentation/strategy';
import { PayloadAction } from '@reduxjs/toolkit';
import { ProductComplexityRanking } from '@snap-types/models/enums';
import { PriceStrategyConfigWithRelations } from '@snap-types/models/price-strategy-config';
import { SnapSuggestionStatus } from '@snap-types/models/sort-status';
import { QuoteLineParams } from '@ui/features/quote-builder/types/shared';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { onPartBaseGrossMarginChange } from '../calculations/recalculate';
import { getQuoteLineOrThrow } from '../utilities/action-guards';

interface Params extends QuoteLineParams {
  productComplexityRanking?: ProductComplexityRanking;
  partProductComplexityRanking?: ProductComplexityRanking;
  priceStrategyConfigs: PriceStrategyConfigWithRelations[];
}

export function quoteLinePartChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const {
    quoteLineUuid,
    productComplexityRanking,
    partProductComplexityRanking,
    priceStrategyConfigs,
  } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  if (quoteLine.partSite && partProductComplexityRanking) {
    quoteLine.partSite.productComplexityRanking = partProductComplexityRanking;
  }

  if (productComplexityRanking) {
    quoteLine.productComplexityRanking = productComplexityRanking;

    const customMargin = getCustomTargetGrossMargin(
      {
        marketIndustry: state.customerIndustry,
        productComplexity: quoteLine.productComplexityRanking,
      },
      quoteLine.lastWin?.grossMargin ?? null,
    );

    if (!customMargin) {
      return;
    }

    for (const uuid of Object.keys(quoteLine.quotePrices)) {
      onPartBaseGrossMarginChange(state, {
        quoteLineUuid: quoteLine.uuid,
        quotePriceUuid: uuid,
        baseGrossMargin: customMargin,
        suggestedPriceStatus: SnapSuggestionStatus.ACCEPTED,
        priceStrategyConfigs,
      });
    }
  }
}
